import { Pipe, PipeTransform } from '@angular/core';

import { OptionsAdminService } from '../services/options-admin.service';

@Pipe({
    name: 'optionsAdminSearchPipe'
})
export class OptionsAdminSearchPipe implements PipeTransform {

    constructor() { }

    transform(value: any[], searchTerm: string) {
        let filteredOptions;
        if (value && searchTerm) {
            if (value.filter(x => (x.OptionDescription !== undefined && x.OptionDescription.toLowerCase().includes(searchTerm.toLowerCase()))
                || (x.OptionNumber !== undefined && x.OptionNumber.toString().includes(searchTerm))
                || (x.AdminOption !== undefined && x.AdminOption !== null && x.AdminOption.CustomerDesc !== undefined && x.AdminOption.CustomerDesc !== null
                    && x.AdminOption.CustomerDesc.toLowerCase().includes(searchTerm.toLowerCase()))
                || (x.AdminOption !== undefined && x.AdminOption !== null && x.AdminOption.CustomerCat !== undefined && x.AdminOption.CustomerCat !== null
                    && x.AdminOption.CustomerCat.toLowerCase().includes(searchTerm.toLowerCase()))).length > 0) {
                filteredOptions = value.filter(x => (x.OptionDescription !== undefined && x.OptionDescription.toLowerCase().includes(searchTerm.toLowerCase()))
                    || (x.OptionNumber !== undefined && x.OptionNumber.toString().includes(searchTerm))
                    || (x.AdminOption !== undefined && x.AdminOption !== null && x.AdminOption.CustomerDesc !== undefined && x.AdminOption.CustomerDesc !== null
                        && x.AdminOption.CustomerDesc.toLowerCase().includes(searchTerm.toLowerCase()))
                    || (x.AdminOption !== undefined && x.AdminOption !== null && x.AdminOption.CustomerCat !== undefined && x.AdminOption.CustomerCat !== null
                        && x.AdminOption.CustomerCat.toLowerCase().includes(searchTerm.toLowerCase())));
            } else {
                filteredOptions = [{ noMatches: true, message: 'No matches found.' }];
            }

            return filteredOptions;
        } else {
            return value;
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/pipes/options-admin-search.pipe.ts